import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/store";
import ContractPaymentNotificationDialog from "./ui/ContractPaymentNotificationDialog";
import { hideContractPaymentNotification } from "../redux/Slices/notificationSlice";
import useContractNotification from "../hooks/useContractNotification";

const GlobalNotifications: React.FC = () => {
  const dispatch = useDispatch();
  const { contractPaymentNotification } = useSelector((state: RootState) => state.notification);

  // Initialize the contract notification WebSocket listener
  useContractNotification();

  // Debug logging
  console.log("GlobalNotifications render - notification state:", contractPaymentNotification);

  const handleHideContractNotification = () => {
    console.log("Hiding contract notification dialog");
    dispatch(hideContractPaymentNotification());
  };

  return (
    <>
      <ContractPaymentNotificationDialog
        key={contractPaymentNotification.data?.contractId || "default"}
        visible={contractPaymentNotification.visible}
        onHide={handleHideContractNotification}
        contractData={contractPaymentNotification.data || undefined}
      />
    </>
  );
};

export default GlobalNotifications;
